var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 18.1667H17.3333M13.1814 6.30333L7.52949 10.6993C7.15168 10.9931 6.96278 11.14 6.82669 11.324C6.70614 11.487 6.61633 11.6707 6.56169 11.8659C6.5 12.0863 6.5 12.3256 6.5 12.8042V18.8333C6.5 19.7667 6.5 20.2335 6.68166 20.59C6.84144 20.9036 7.09641 21.1585 7.41002 21.3183C7.76654 21.5 8.23325 21.5 9.16667 21.5H18.8333C19.7668 21.5 20.2335 21.5 20.59 21.3183C20.9036 21.1585 21.1586 20.9036 21.3183 20.59C21.5 20.2335 21.5 19.7667 21.5 18.8333V12.8042C21.5 12.3256 21.5 12.0863 21.4383 11.8659C21.3837 11.6707 21.2939 11.487 21.1733 11.324C21.0372 11.14 20.8483 10.9931 20.4705 10.6993L14.8186 6.30333C14.5258 6.07562 14.3794 5.96177 14.2178 5.918C14.0752 5.87938 13.9248 5.87938 13.7822 5.918C13.6206 5.96177 13.4742 6.07562 13.1814 6.30333Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.29f2ef1eefff19da16b29e9d4efbdb0a.svg";
export { ForwardRef as ReactComponent };